import styles from "./SectionDivider.module.scss";
import { classNames } from "primereact/utils";
import { useAppContext } from "../../../../AppContext";

import { dvSize } from "../../../infrastructure/utilities/viewportUnitsUtility";
interface ISectionDividerProps {
  label: string;
  className?: string;
  width?: string;
}

export const SectionDivider = ({
  label,
  className,
  width,
}: ISectionDividerProps) => {
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    width = isDesktopOrTablet ? "600px" : dvSize("80dvw");
  }

  return (
    <div
      className={classNames(styles.root, className)}
      style={{ width }}
    >
      <span className={styles.root_text}>{label}</span>
    </div>
  );
};
